export default {
      id: "hammock-usage",
      viewBox: "0 0 1991.134 1263.104",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#hammock",
      toString: function () {
        return this.url;
      }
    }